import { render, staticRenderFns } from "./PlannerAssignSchool.vue?vue&type=template&id=24d782e7&scoped=true"
import script from "./PlannerAssignSchool.vue?vue&type=script&lang=js"
export * from "./PlannerAssignSchool.vue?vue&type=script&lang=js"
import style0 from "./PlannerAssignSchool.vue?vue&type=style&index=0&id=24d782e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d782e7",
  null
  
)

export default component.exports